export default __webpack_public_path__ + "static/bolanle-1e51a1d446bd68cd6ed1f32a72ebe5b4.png";